import { buildQueryParamLink } from 'lib/helpers/urlHelper';
import safeFetch from 'lib/requests/fetch';

export interface ISoftLoginResponse {
  isAuthCookieSet: boolean;
}

export const getSoftLogin = async (key?: string) =>
  safeFetch<ISoftLoginResponse>(
    buildQueryParamLink('/soft-login', { key }),
    {},
    { dontRedirect: true }
  );
